export default __webpack_public_path__ + "static/praise-024fdc27de23d3eb4fe59703863433cc.gif";